<template>
  <div class="management-agent-box">
    <div class="content-box">
      <!-- 搜索栏 -->
      <div class="content_title data_screen">
        <div class="data_screen_line">
          <span class="title">操作日志</span>

          <span>
            <el-input
              v-model="search.content"
              placeholder="姓名，手机号"
              style="width: 300px"
              size="small"
              suffix-icon="el-icon-search"
              @change="pageChange(1)"
              clearable
            />
          </span>
          <span class="data_screen_tab">
            <!-- 分类  -->
            <el-select
              v-model="search.openType"
              clearable
              placeholder="请选择"
              size="small"
              style="width: 150px"
              @change="pageChange(1)"
            >
              <el-option label="全部类型" value />
              <el-option
                v-for="item in openTypes"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </span>
          <span class="data_screen_tab">
            <!-- 分类  -->
            <el-select
              v-model="search.openClass"
              clearable
              placeholder="请选择"
              size="small"
              style="width: 150px"
              @change="pageChange(1)"
            >
              <el-option label="全部分类" value />
              <el-option
                v-for="item in openClass"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </span>
          <el-button
            class="btn search_btn"
            size="small"
            @click="pageChange(1)"
            >查询</el-button>
        </div>
      </div>
      <!-- 具体内容 -->
      <div class="content">
        <div class="content_auto">
          <!-- 表格 -->
          <el-table :data="table_data" style="width: 100%">
            <el-table-column
              prop="name"
              label="姓名"
              align="center"
              width="120"
            ></el-table-column>
            <el-table-column
              prop="phone"
              label="手机号"
              align="center"
              width="150"
            ></el-table-column>
            <el-table-column prop="adminType" label="管理员类型" align="center" width="120">
              <template slot-scope="scope">
                <span v-if="scope.row.adminType == 1">超级管理员</span>
                <span v-else>普通管理员</span>
              </template>
            </el-table-column>
            <el-table-column
              prop="phoneBrand"
              label="操作类型"
              align="center"
              width="120"
            >
              <template slot-scope="scope">
                <span v-if="scope.row.type == 1">登录</span>
                <span v-else-if="scope.row.type == 2">增加</span>
                <span v-else-if="scope.row.type == 3" style="color: green">修改</span>
                <span v-else-if="scope.row.type == 4" style="color: red">删除</span>
                <span v-else style="color: red">未知</span>
              </template>
            </el-table-column>
            <el-table-column
              prop="phoneModel"
              label="操作分类"
              align="center"
              width="120"
            >
              <template slot-scope="scope">
                <span v-if="scope.row.funType == 1">登录</span>
                <span v-else-if="scope.row.funType == 2">管理员</span>
                <span v-else-if="scope.row.funType == 3">课程分类</span>
                <span v-else-if="scope.row.funType == 4">课程列表</span>
                <span v-else-if="scope.row.funType == 5">轮播图</span>
                <span v-else style="color: red">未知</span>
              </template>
            </el-table-column>
            <el-table-column
              prop="createTime"
              label="操作时间"
              align="center"
              width="180"
            ></el-table-column>
            <el-table-column
              prop="remarks"
              label="具体事项"
              align="left"
            ></el-table-column>
            
          </el-table>
          <!-- 表格结束 -->
          <!-- 分页 -->
          <div class="page">
            <el-pagination
              background
              layout="total,prev, pager, next"
              :total="page.total"
              :page-size="page.size"
              @current-change="pageChange"
            ></el-pagination>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      // 搜索
      search: {
        content: null,
        openType: "",
        openClass: ""
      },
      openTypes: [
        { label: "登录", value: 1 },
        { label: "增加", value: 2 },
        { label: "修改", value: 3 },
        { label: "删除", value: 4 }
      ],
      openClass: [
        { label: "登录", value: 1 },
        { label: "管理员", value: 2 },
        { label: "课程分类", value: 3 },
        { label: "课程列表", value: 4 },
        { label: "轮播图", value: 5 }
      ],
      // 分页属性
      page: {
        currPage: 1,
        size: 15,
        total: 100,
      },
      // 表格数据
      table_data: [],
      // return 结束
    };
  },
  updated() {},
  created() {
    this.query();
  },
  methods: {
    // 分页改变
    pageChange(res) {
      this.page.currPage = res;
      this.query();
    },
    // 查询数据
    query() {
      let that = this;
      const url = "/api/web/admin/log/queryLog";
      that.table_data = [];
      this.$axios
        .post(url, {
          page: this.page.currPage,
          size: this.page.size,
          param:{
            name: this.search.content,
            type: this.search.openType,
            funType: this.search.openClass
          }
        })
        .then((res) => {
          if (res.data.code == 1000) {
            that.table_data = res.data.data.list;
            that.page.total = Number(res.data.data.totalItems);
          } else if (res.data.code == 4030) {
          } else if (res.data.code == 2001) {
            that.$message.error("登录失效，请重新登录");
            that.$router.push({ path: "/login" });
          } else {
            that.$message.info(res.data.message);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // methods 结束
  },
};
</script>

<style scoped>
/* 外盒子 */
.management-agent-box {
  height: 100%;
  width: 100%;
  padding: 15px;
  background: #f8fafb;
}
/* 内盒子 */
.content-box {
  width: 100%;
  height: 100%;
}
/* 内容盒子 */
.content_title {
  width: 100%;
  background: #ffffff;
  padding-left: 30px;
  padding-right: 30px;
  padding-top: 10px;
  border-radius: 5px;
}

/* 内容盒子 */
.content {
  width: 100%;
  height: calc(100% - 90px);
  /* height: 100%; */
  background: #ffffff;
  padding-left: 30px;
  padding-right: 30px;
  padding-top: 10px;
  padding-bottom: 10px;
  border-radius: 5px;
}
.content_auto {
  height: 100%;
  overflow-y: auto;
}
/* 滚动条样式 */
.content_auto::-webkit-scrollbar {
  /*滚动条整体样式*/
  width: 6px; /*高宽分别对应横竖滚动条的尺寸*/
  height: 1px;
}
.content_auto::-webkit-scrollbar-thumb {
  /*滚动条里面小方块*/
  border-radius: 10px;
  box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  background: #00cb9f;
}
.content_auto::-webkit-scrollbar-track {
  /*滚动条里面轨道*/
  box-shadow: inset 0 0 5px rgba(167, 163, 163, 0.2);
  border-radius: 10px;
  background: #ededed;
}

/* 搜索栏 */
.data_screen {
  height: 90px;
  margin-bottom: 15px;
  padding-top: 0px;

  display: flex;
  justify-content: center;
  align-items: flex-start;
  flex-direction: column;
}

/* 搜索栏居中 */
.data_screen_line {
  line-height: 32px;
  width: 100%;
  display: flex;
  justify-content: start;
  align-items: flex-start;
}

.data_screen .data_screen_tab {
  margin-left: 20px;
}
/* 标题 */
.title {
  margin-right: 30px;
  font-family: PingFangSC-Semibold;
  font-size: 16px;
  color: #454647;
  letter-spacing: 0;
}

/* 分页 */
.page {
  /* position:absolute;
  bottom: 50px;
  right: 50px; */
  float: right;
  margin-top: 20px;
}
/* 查询按钮 */
.search_btn{
  margin-left: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/views/log/enterpriseLog.vue